module.exports = __webpack_public_path__ + "static/media/kevinsPage.a0f652d7.jpg";